import { httpPost, httpGet, httpPostFile } from '../../../../utils/api.utils';
import { actions } from 'react-redux-form';
import { batch } from 'react-redux';
import Moment from 'moment';
import { convertDateStringToDateFormat } from "../../../../utils/helpers.utils";

import {
    getContractDropdownList,
    setFinanceContractError,
    contractModel,
    contractCommitmentModel,
    setFinanceContractLoading,
    getVendorList,
    getServiceList
} from "../../../../constants/model-reducers/external/finance/contract/contract-details.settings"
import { DEFAULT_TABLE_RESULT_FINANCE_CONTRACT_DROPDOWN_MODEL } from '../../../../constants/external-constants';
import { convertToDecimal } from '../../../../utils/helpers.utils';


const defaultState = () => (
    {
        isLoaded: false
        , isDropdownListLoaded: false
        , activeVendors: []
        , isError: false
        , dropDownPage: 0
        , isVendorListLoaded: false
        , isServiceListLoaded: false
        , vendorList: []
        , serviceList: []
    }
);

const initialState = defaultState();

export const contractInitalState = contractModel;
export const contractCommitmentInitialState = contractCommitmentModel;

export const FinanceContractFormActions = {

    getContractFormDetails: (contractId) => async (dispatch) => {
         var result = await httpGet(`external/finance/getContractFormDetails/${contractId ?? 0}`);
        
                if (result != null){ 
                    batch(() => {
                        //Contract Details
                        dispatch(actions.load('contractForm.contract.contractCode', result.contractFormDetails.ContractCode));
                        dispatch(actions.load('contractForm.contract.contractName', result.contractFormDetails.ContractName));
                        dispatch(actions.load('contractForm.contract.vendorDetailId', result.contractFormDetails.VendorDetailID));
                        dispatch(actions.load('contractForm.contract.currency', result.contractFormDetails.Currency));
                        dispatch(actions.load('contractForm.contract.contractStatusId', result.contractFormDetails.ContractStatusID.toString()));
                        dispatch(actions.load('contractForm.contract.circuitTypeId', result.contractFormDetails.CircuitTypeID));
                        dispatch(actions.load('contractForm.contract.termLength', result.contractFormDetails.TermLength));
                        dispatch(actions.load('contractForm.contract.utilization', result.contractFormDetails.Utilization != null ? result.contractFormDetails.Utilization : 0.00));
                        dispatch(actions.load('contractForm.contract.evergreenStatusId', result.contractFormDetails.EvergreenStatusID.toString()));
                        dispatch(actions.load('contractForm.contract.effectiveDate', convertDateStringToDateFormat(result.contractFormDetails.EffectiveDate, false)));
                        dispatch(actions.load('contractForm.contract.expirationDate', convertDateStringToDateFormat(result.contractFormDetails.ExpirationDate, false)));
                        dispatch(actions.load('contractForm.contract.files', result.contractFormDetails.AttachmentDetails));

                        //Contract Commitment
                        dispatch(actions.load('contractForm.contractCommitment.termCommitmentVolume', result.contractFormDetails.TermCommitmentVolume != null ? result.contractFormDetails.TermCommitmentVolume : ""));
                        dispatch(actions.load('contractForm.contractCommitment.annualCommitmentVolume', result.contractFormDetails.AnnualCommitmentVolume != null ? result.contractFormDetails.AnnualCommitmentVolume : ""));
                        dispatch(actions.load('contractForm.contractCommitment.subCommitment', result.contractFormDetails.SubCommitment != null ? result.contractFormDetails.SubCommitment : ""));
                        dispatch(actions.load('contractForm.contractCommitment.escalatingCommitment', result.contractFormDetails.EscalatingCommitment != null ? result.contractFormDetails.EscalatingCommitment : ""));
                        dispatch(actions.load('contractForm.contractCommitment.exclusivity', result.contractFormDetails.Exclusivity != null ? result.contractFormDetails.Exclusivity : ""));
                        dispatch(actions.load('contractForm.contractCommitment.description', result.contractFormDetails.Description != null ? result.contractFormDetails.Description : ""));

                    });
                }
    },

    getContractDropdownList: () => async (dispatch) => {
        var res = await httpGet('external/finance/getContractDropdownList');
 
        if (res != null) {
            dispatch({
                type: getContractDropdownList,
                isDropdownListLoaded: true,
                contractDropdownList: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_FINANCE_CONTRACT_DROPDOWN_MODEL,
            });
        }
        else {
            dispatch({
                type: setFinanceContractError,
                isDropdownListLoaded: false,
                isError: true
            });
        }
    },

    getVendorList: (page=1, searchString='') => async (dispatch, getState) => {

        if (getState().isVendorListLoaded) return;

        const pageSize = 15;

        dispatch({ 
           type: getVendorList,
           isVendorListLoaded: false 
       });
                
        var url = `external/finance/fetchVendors/${page}/${pageSize}`;

        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        
        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getVendorList,
                isVendorListLoaded: true,
                vendorList: res?.vendors?.length > 0 ? res?.vendors : [],
                hasMoreData: res.hasMoreData,
                page: page,
            });
        }
        else {
            dispatch({
                type: getVendorList,
                isVendorListLoaded: false,
                vendorList: [],
                isError: true
            });
        }
    },

    getServiceTypeList: (page=1, searchString='') => async (dispatch, getState) => {

        if (getState().isServiceListLoaded) return;

        const pageSize = 15;

        dispatch({ 
           type: getServiceList,
           isServiceListLoaded: false 
       });
                
        var url = `external/finance/getServiceTypesList/${page}/${pageSize}`;

        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        
        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getServiceList,
                isServiceListLoaded: true,
                serviceList: res?.serviceTypes?.length > 0 ? res?.serviceTypes : [],
                hasMoreServiceData: res.hasMoreData,
                page: page,
            });
        }
        else {
            dispatch({
                type: getServiceList,
                isServiceListLoaded: false,
                isError: true
            });
        }
    },
    
    getSelectedVendor: (vendorDetailId) => async (dispatch) => {
        var res = await httpGet('external/finance/getSelectedVendor' + '/' + vendorDetailId);
        return res;
    },
    
    getSelectedServiceType: (serviceTypeID) => async (dispatch) => {
        var res = await httpGet('external/finance/getSelectedServiceType' + '/' + serviceTypeID);
        return res;
    },

    getSelectedVendorCurrency: (vendorDetailId) => async (dispatch) => {
        var res = await httpGet('external/finance/getSelectedVendorCurrency' + '/' + vendorDetailId);

        if (res != null) {
            dispatch(actions.change('contractForm.contract.currency', res));
        }
        else {
            dispatch({
                type: setFinanceContractError,
                isError: true
            });
        }
    },

    saveFinanceContract: (contractId, validate, files, fileNames) => async (dispatch, state) => {
        const { contract, contractCommitment } = state().form.contractForm

        try {
            var formData = new FormData();

            formData.append("ContractID", contractId);
            formData.append("Validate", validate);
            formData.append("ContractCode", contract.contractCode);
            formData.append("ContractName", contract.contractName);
            formData.append("VendorDetailID", contract.vendorDetailId);
            formData.append("ContractStatusID", contract.contractStatusId);
            formData.append("CircuitTypeID", contract.circuitTypeId);
            formData.append("TermLength", contract.termLength);
            formData.append("Utilization", contract.utilization != "" ? contract.utilization : convertToDecimal(0));
            formData.append("EvergreenStatusID", contract.evergreenStatusId);
            formData.append("EffectiveDate", contract.effectiveDate ? Moment(contract.effectiveDate).format('YYYY-MM-DD') : null);
            formData.append("ExpirationDate", contract.expirationDate ? Moment(contract.expirationDate).format('YYYY-MM-DD') : null);
            //Append contract commitment
            formData.append("TermCommitmentVolume", contractCommitment.termCommitmentVolume);
            formData.append("AnnualCommitmentVolume", contractCommitment.annualCommitmentVolume);
            formData.append("SubCommitment", contractCommitment.subCommitment);
            formData.append("EscalatingCommitment", contractCommitment.escalatingCommitment);
            formData.append("Exclusivity", contractCommitment.exclusivity);
            formData.append("Description", contractCommitment.description);

            if (files && files.length > 0) {
                let flatFiles = files.flat();
                flatFiles.forEach((file) => {
                    formData.append("FileData", file);
                });
            }

            if (contract.files && contract.files.length > 0) {
                contract.files.forEach((file) => {
                    if (file.previewUrl && file.originalFileName) {
                        formData.append("UnchangedFileNames", file.originalFileName);

                    }
                });
            }
            
            var result = await httpPostFile('external/finance/saveContract', formData);

            if(result.isExist){
                dispatch(actions.setErrors('contractForm.contract.contractCode', true));
                dispatch(actions.setErrors('contractForm.contract.contractName', true));
            }
        }
        catch (e) {
            return e;
        }
        return result;
    },

    resetContractForm: () => (dispatch) => {
        dispatch(actions.reset('contractForm'));
        dispatch(actions.reset('contractForm.contract'));
        dispatch(actions.reset('contractForm.contractCommitment'));
    }
}

export const reducer = (state, action) => {
    state = state || initialState
    switch (action.type) {
        case getContractDropdownList:
        return {
            ...state,
            isDropdownListLoaded: action.isDropdownListLoaded,
            contractDropdownList: action.contractDropdownList
        };

        case setFinanceContractLoading:
        return {
            ...state,
            isDropdownListLoaded: action.isDropdownListLoaded
        }

        case getVendorList:
            return {
                ...state,
                vendorList: action.page === 1? action.vendorList ?? [] : [...state.vendorList, ...action.vendorList ?? []],
                hasMoreVendor: action.hasMoreData,
                isVendorListLoaded: action.isVendorListLoaded,
                vendorListPage: action.page
            }
        
        case getServiceList:
            
            return {
                ...state,
                serviceList: action.page === 1? action.serviceList ?? [] : [...state.serviceList, ...action.serviceList ?? []],
                hasMoreService: action.hasMoreServiceData,
                isServiceListLoaded: action.isServiceListLoaded,
                serviceListPage: action.page
            }
        default:
            return state;
    }
}